import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, null, -1)
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Debut ", -1)
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Fin ", -1)
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Client ", -1)
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Vente ", -1)
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Agent ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "table-responsive" }
const _hoisted_26 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " DATE "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " CLIENT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " MONTANT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " MT RESTANT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " VENTE "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " GROUPEMENT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " AGENT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, "Actions")
  ])
], -1)
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "badge text-white bg-primary fs-15 dropdown-toggle",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      /*#__PURE__*/_createTextVNode(" Actions "),
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" })
  ])
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-end"
}, " Total : ", -1)
const _hoisted_37 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, {
                style: {"max-height":"42px"},
                modelValue: _ctx.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                onKeyup: _ctx.rechercher,
                name: "mot",
                type: "text",
                "aria-disabled": "true",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Recherche par mot clé"
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Field, {
                name: "dateDebut",
                type: "date",
                modelValue: _ctx._dateDebut,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._dateDebut) = $event)),
                value: _ctx.getCurrentDate(),
                class: "form-control shadow-none fs-md-15 text-black"
              }, null, 8, ["modelValue", "value"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateDebut",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Field, {
                name: "dateFin",
                type: "date",
                modelValue: _ctx._dateFin,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._dateFin) = $event)),
                value: _ctx.getCurrentDate(),
                class: "form-control shadow-none fs-md-15 text-black"
              }, null, 8, ["modelValue", "value"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_Field, {
                modelValue: _ctx._client,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._client) = $event)),
                name: "client"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    options: 
                    async (query) => {
                      const results = await _ctx.searchClient(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [
                          { value: '', label: 'Aucun enregistrement trouvé' },
                        ];
                      } else {
                        return [];
                      }
                    },
                    noOptionsText: "Tapez au moins deux caractères",
                    "filter-results": false,
                    "min-chars": 3,
                    delay: 0,
                    searchable: true,
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner un client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "client",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_Field, {
                modelValue: _ctx._vente,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._vente) = $event)),
                name: "vente"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    options: _ctx.venteOptions,
                    searchable: true,
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner une vente" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "vente",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_Field, {
                modelValue: _ctx._agent,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx._agent) = $event)),
                name: "agent"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    options: _ctx.agentOptions,
                    searchable: true,
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner un agent" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "agent",
                class: "text-danger"
              })
            ])
          ])
        ])
      ]),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("table", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reglements, (reg, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.format_Date(reg.dateReglement)), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(reg.vente?.client?.code), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(reg.montant), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString(reg.restAPayer), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString('#'+reg.vente?.id), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(reg?.groupementReglement?.id), 1),
                _createElementVNode("td", _hoisted_34, _toDisplayString(reg?.vente?.client?.agent?.nom + ' ' + reg?.vente?.client?.agent?.prenoms), 1),
                _hoisted_35
              ]))
            }), 128)),
            _createElementVNode("tr", null, [
              _hoisted_36,
              _createElementVNode("td", null, [
                _createElementVNode("h5", null, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.formatMontant(_ctx.total)), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}